export const hasActiveChild = (item, currentURL) => {
  const { subNav } = item
  if (!subNav) {
    return false
  }
  for (const child of subNav) {
    if (child.subNav) {
      if (hasActiveChild(child, currentURL)) {
        return true
      }
    }
    const childPath = child.path

    if (
      child &&
      childPath &&
      currentURL &&
      (childPath === currentURL ||
        (currentURL.includes(childPath) && childPath !== '/'))
    ) {
      return true
    }
  }

  return false
}

export const EditorOption = [
  'inline',
  'blockType',
  'fontSize',
  'fontFamily',
  'list',
  'textAlign',
  'colorPicker',
  'link',
  'embedded',
  'emoji',
  'remove',
  'history'
]

export const hijriMonthsFull = [
  { name: 'Muharram', no: '01' },
  { name: 'Safar', no: '02' },
  { name: 'Rabi ul Awwal', no: '03' },
  { name: 'Rabi us Saani', no: '04' },
  { name: 'Jamadi ul Awwal', no: '05' },
  { name: 'Jamadi us Saani', no: '06' },
  { name: 'Rajab', no: '07' },
  { name: 'Shabaan', no: '08' },
  { name: 'Ramzaan', no: '09' },
  { name: 'Shawwal', no: '10' },
  { name: 'Dhual Qadah', no: '11' },
  { name: 'Dhual Hijjah', no: '12' }
]
export const day = [
  '01st',
  '02nd',
  '03rd',
  '04th',
  '05th',
  '06th',
  '07th',
  '08th',
  '09th',
  '10th',
  '11th',
  '12th',
  '13th',
  '14th',
  '15th',
  '16th',
  '17th',
  '18th',
  '19th',
  '20th',
  '21st',
  '22nd',
  '23rd',
  '24th',
  '25th',
  '26th',
  '27th',
  '28th',
  '29th',
  '30th'
]

export const dataset = [
  {
    announcement: {
      view: false,
      edit: false,
      delete: false
    },
    library: {
      view: false,
      edit: false,
      delete: false
    },
    program: {
      view: false,
      edit: false,
      delete: false,
    },
    // "day's_adjustment": {
    //   view: false,
    //   edit: false,
    //   delete: false
    // },
    team: {
      view: false,
      edit: false,
      delete: false
    },
    business: {
      view: false,
      edit: false,
      delete: false
    },
    user: {
      view: false,
      edit: false,
      delete: false
    },
    feedback: {
      view: false,
      edit: false,
      delete: false
    },
    donation: {
      view: false,
      edit: false,
      delete: false
    },
    donation_type: {
      view: false,
      edit: false,
      delete: false
    },
    general_setting: {
      view: false,
      edit: false,
      delete: false
    },
    calender_setting: {
      view: false,
      edit: false,
      delete: false
    },
    banner: {
      view: false,
      edit: false,
      delete: false
    }
  }
]

export const isRolePermission = (modulePermissions, userData) => {
  try {
    if (userData?.data?.user?.role === '1') {
      return true
    } else if (userData?.data?.user?.config[modulePermissions]?.view) {
      return true
    } else {
      return false
    }
  } catch (error) {
    console.error(error)
  }
  return false
}
